<template>
  <div id="sig-container" class="full form-horizontal">
    <div class="widget">
      <div class="widget-content widget-content-mini themed-background-dark-default text-light">
        <span class="float-right text-muted">
          <button type="button" @click="$router.go(-1)" class="btn btn-xs btn-primary">Volver</button>
        </span>
        Información de contacto
      </div>
      <div class="widget-content border-bottom themed-background-muted text-center">
        <div class="container">
          <div class="form-group text-center"></div>
          <div class="form-group">
            <label class="control-label col-lg-3 col-md-2" v-text="'Documento'"></label>
            <div class="col-lg-12 col-md-12">
              <input
                type="text"
                class="form-control"
                v-model="params.documento"
                placeholder="Documento"
              />
            </div>

            <label class="control-label col-lg-3 col-md-2" v-text="'Tipo de contacto'"></label>
            <div class="col-lg-12 col-md-12">
              <select class="form-control" id="datos_usuarios" v-model="params.tipo_contacto">
                <option :value="null">Seleccione el tipo</option>
                <option v-for="tipo in tipos" :key="tipo.value" :value="tipo.nombre">{{tipo.nombre}}</option>
              </select>
            </div>

            <label class="control-label col-lg-3 col-md-2" v-text="'Rango de calificación'"></label>
            <div class="col-lg-12 col-md-12">
              <input type="number" class="form-control" v-model="params.min" placeholder="Min" />

              <input type="number" class="form-control" v-model="params.max" placeholder="Max" />
            </div>
          </div>
          <div class="form-actions">
            <button class="btn btn-primary" @click="getContactos()">Aplicar</button>&nbsp;
            <!--button class="btn btn-primary" @click="descargarConsulta()">Descargar excel</button-->
          </div>
        </div>
      </div>
    </div>

    <br />

    <table-component :data="contactos" @click-event="clickEvent" pagination>
      <table-column slot="label" :label="'ID'" v-bind:value="'id'"></table-column>
      <table-column slot="label" :label="'Identificación'" v-bind:value="'deudor.identificacion'"></table-column>
      <table-column slot="label" :label="'Deudor'" v-bind:value="'deudor.nombre'"></table-column>
      <table-column slot="label" :label="'Calificación'" v-bind:value="'calificacion'"></table-column>
      <table-column slot="label" :label="'Descripcion'" v-bind:value="'descripcion'"></table-column>
      <table-column slot="label" :label="'Valor'" v-bind:value="'valor'"></table-column>

      <table-column slot="label" :label="'Acciones'" :icon="'fa'">
        <template
          slot="icon"
          :icon="'fa fa-check'"
          :class="'btn btn-sm btn-primary'"
          :slug="'validar-contacto'"
          :tooltip="'Validar Contacto'"
        ></template>
        <template
          slot="icon"
          :icon="'fa fa-trash'"
          :class="'btn btn-sm btn-primary'"
          :slug="'borrado-logico'"
          :tooltip="'Borrar'"
        ></template>
      </table-column>
    </table-component>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "RegistrosInvalidos",
  data: () => {
    return {
      params: {
        min: null,
        max: null,
        tipo_contacto: null,
        documento: null
      },
      tipos: [
        {
          nombre: "Dirección",
          value: "direccion"
        },
        {
          nombre: "Telefono",
          value: "telefono"
        },
        {
          nombre: "E-mail",
          value: "email"
        }
      ],
      deudores: [],
      errors: null
    };
  },
  computed: {
    ...mapGetters({ contactos: "contacto/contactos" })
  },
  components: {
    TableComponent: () => import("@@/components/table/TableComponent"),
    TableColumn: () => import("@@/components/table/TableColumn")
  },
  methods: {
    getContactos() {
      this.$store
        .dispatch("index", {
          endpoint: "contacto/invalidos",
          params: this.params
        })
        .then(response => {
          if (response.length > 0) {
            this.$store.dispatch("contacto/refresh_contactos", response);
          } else {
            //this.$router.push({ path: "/" });
            this.$store.dispatch("contacto/refresh_contactos", response);
            this.$notify({
              title: "Advertencia!",
              type: "warning",
              content: "No se encontró información con los datos dados"
            });
          }
        })
        .catch(() => {
          this.$notify({
            title: "Advertencia!",
            type: "danger",
            content: "Se ha presentado un error realizando su consulta"
          });
        });
    },
    borrarContacto(contacto) {
      this.$store
        .dispatch("remove", { endpoint: "contacto/" + contacto.id })
        .then(response => {
          this.$notify({
            title: "Invalidado!",
            type: "success",
            content: "Se eliminó el contacto satisfactoriamente"
          });
        })
        .catch(() => {
          this.$notify({
            title: "Advertencia!",
            type: "warning",
            content: "Ha ocurrido un problema eliminando el contacto"
          });
        });
    },
    validarContacto(contacto) {
      contacto.invalido = 0;

      this.$store
        .dispatch("edit", {
          endpoint: "contacto/" + contacto.id,
          params: contacto
        })
        .then(response => {
          this.$notify({
            title: "Validado!",
            type: "success",
            content: "Se validó el contacto satisfactoriamente"
          });
          this.getContactos();
        })
        .catch(() => {
          this.$notify({
            title: "Advertencia!",
            type: "warning",
            content: "Ha ocurrido un problema validando el contacto"
          });
        });
    },
    clickEvent(data, slug) {
      switch (slug) {
        case "borrado-logico":
          this.borrarContacto(data);
          break;
        case "validar-contacto":
          this.validarContacto(data);
          break;
      }
    }
  },
  mounted() {
    this.getContactos();
  }
};
</script>
<style>
#space {
  padding-top: 10px;
}
#datepicker {
  background: white;
  padding-top: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
}
.disponibles {
  display: flow-root !important;
}
.titulos-disponible {
  padding-left: initial !important;
  padding-right: initial !important;
}
.table thead > tr > th {
  font-size: 14px !important;
}

.table thead > tr > td {
  font-size: 10px !important;
}

.table-responsive {
  overflow: auto !important;
  width: 100%;
}
</style>